import '@/themes/generated/variables.css'
import { Outlet, useMatches } from 'react-router-dom'
import { useScreenSizeClass } from '@/themes/media-query'
import React, { StrictMode, useEffect } from 'react'
import '@/routes/authenticated/AuthenticatedLayout.scss'
import { SideNavOuterToolbar } from '@/layouts'
import { useNotificationService } from '@/services/notificationService'
import { useQsAdminApiManager } from '@/auth/api/qsadminapiManager'
import { qnotifica } from '@/model/qsadminapi/QQsAdminApiModule'
import { TypedMatch } from '@/types'
import DocumentHead from '@/components/document-head/DocumentHead'

export const AuthenticatedLayout = () => {
  const [title, setTitle] = React.useState('Qs Web Admin')
  const notificationService = useNotificationService()
  const matches = useMatches() as Array<TypedMatch<void>>

  useEffect(() => {
    const setDbNotifications = async () => {
      const notifications = await useQsAdminApiManager
        .getState()
        .service.notifica()
        .query((builder) => builder.filter(qnotifica.gestita.isFalse()))
      notificationService.notifications = notifications.data.value.map((notification) => notification.id)

      // Initialize idle detection ONCE before connecting
      notificationService.initializeIdleDetection()

      await notificationService.connect()
    }
    // setDbNotifications()

    // Cleanup on unmount
    return () => {
      notificationService.cleanup()
      notificationService.disconnect()
    }
  }, [])

  return (
    <div className={`app ${useScreenSizeClass}`}>
      <DocumentHead matches={matches}></DocumentHead>
      <SideNavOuterToolbar title={title}>
        <StrictMode>
          <Outlet />
        </StrictMode>
      </SideNavOuterToolbar>
    </div>
  )
}
